export default {
    breadcrumbs: {
        company: 'Kompanija',
        my_company: 'Moje kompanije',
        preview: 'Profil kompanije',
    },
    tabs: {
        profile: 'Profil',
        personal_details: 'Podešavanja',
        settings: 'Podešavanja',
        gallery: 'Galerija',
        locations: 'Lokacije',
        services: 'Usluge',
        users: 'Korisnici',
        inactivity: 'Neaktivnost',
        discount: 'Popusti',
        invoices: 'Fakture',
        clients: 'Klijenti',
        client: 'Klijent',
        chart: 'Statistika',
        reminder: 'Podsjetnici',
        performers: 'Radnici',
    },
    offer_tabs: {
        active: 'Aktivni ({number})',
        renewal: 'Za obnovu ({number})',
        expired: 'Istekli ({number})',
    },
    buttons: {
        upload_company_logo: 'Učitajte logo kompanije',
        change_cover_photo: 'Promijeni sliku',
        add_inactivity: 'Dodaj neaktivnost',
        add_discount: 'Dodaj popust',
    },
    no_added_inactivity: 'Nemate dodatih neaktivnosti!',
    no_added_invoice: 'Nemate faktura!',
    delete_company: 'Obrišite kompaniju',
    reactivate_company: 'Aktivirajte kompaniju',
    successfully_deleted: 'Kompanija uspiješno obrisana',
    successfully_reactivated: 'Kompanija uspiješno reaktivirana',
    delete_company_modal_heading: 'Da li ste sigurni da želite da deaktivirate kompaniju?',
    activate_company_modal_heading: 'Da li ste sigurni da želite da ponovo aktivirate kompaniju?',
    no_added_reminders: 'Nemate dodatih podsjetnika!',
    outstandingsAmountCompanies: 'Više Vaših kompanija ima dugovanja. Molimo Vas da ih izmirite.',
    outstandingsAmountCompany: 'Imate dugovanje od {n} {m} u kompaniji {c}. Molimo Vas da ga uskoro izmirite.',
    search_performer: 'Pretraži radnika',

    errors: {
        not_found: 'Kompanija nije pronadjena',
        already_active: 'Kompanija je vec aktivna',
        is_in_debt: 'Molimo vas izmirite dugove',
    },
}
